import { useContext } from 'react';
import { StoreContext } from '@roc/client-portal-shared/context';
import { CRMPortalStore } from '../stores';

export const useCRMPortalStore = () =>
  useContext<CRMPortalStore>(StoreContext);
